import { useQuery } from "react-query";
import { kebabCase } from "lodash";
import useQueryState from "./useQueryState";
import { getAnomaliesGeographicalUnitValuesService } from "../services/timeseries";
import { QueryLayer } from "../types/queryState";
import Cookies from "js-cookie";
import { useAuthContext } from "./useAuthContext";
import { useUIStore } from "../store/ui";
import { buildIndicatorName } from "../helpers/indicatorName";

const accessToken = () => Cookies.get("accessToken");

const useGeoUnitAnomaliesValues = ({
  layers,
  season,
  isEnabled,
}: {
  layers: QueryLayer[];
  season: string;
  isEnabled: boolean;
}) => {
  const { parsedToken } = useAuthContext();
  const { email: userEmail } = parsedToken || {};
  const {
    queryState: { country, aggregationLevel, layers: queryLayers },
  } = useQueryState();

  const { displayName } = layers[0];
  const selectedLayer = queryLayers.find(
    (layer) => layer.displayName === displayName && layer.season === season,
  );
  const isDetrended = useUIStore((s) => s.isDetrended);
  const isLandCoverMasked = useUIStore((s) => s.isLandCoverMasked);
  const isSystemType =
    aggregationLevel === "0" ||
    aggregationLevel === "1" ||
    aggregationLevel === "2";
  const indicatorName = buildIndicatorName(displayName, {
    isLandCoverMasked,
    isDetrended,
  });

  const getAnomaliesGeographicalUnitValues = useQuery(
    [
      "geoUnit",
      "anomaly",
      country,
      indicatorName,
      aggregationLevel,
      selectedLayer?.months,
      selectedLayer?.dekads,
      isSystemType ? "system" : "user",
      accessToken() ? userEmail : "",
      isDetrended,
      isLandCoverMasked,
      // year
    ],
    async () => {
      const response = await getAnomaliesGeographicalUnitValuesService({
        country,
        indicator: indicatorName,
        adminLevel: aggregationLevel,
        startmonth: selectedLayer?.months[0] ?? "",
        endmonth: selectedLayer?.months[1] ?? "",
        startDekad: selectedLayer?.dekads[0] ?? "",
        endDekad: selectedLayer?.dekads[1] ?? "",
        type: isSystemType ? "system" : "user",
        // year,
      });

      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      enabled:
        !!country &&
        !!aggregationLevel &&
        !!selectedLayer &&
        selectedLayer?.months.every((m) => !!m) &&
        !!season &&
        isEnabled,
    },
  );

  return {
    getAnomaliesGeographicalUnitValues,
  };
};

export default useGeoUnitAnomaliesValues;
